import { Link } from 'react-router-dom'
import styles from './LegalDocumentPage.module.css'
import { CONTACT_EMAIL, PRIVACY_EMAIL } from '@/config/sales'
const DELETE_SUBJECT = encodeURIComponent('Pedido de eliminação de conta — agendamentos')
const DELETE_BODY = encodeURIComponent(
  'Quero eliminar a minha conta e os dados associados.\n\nE-mail da conta:\nNome (se souber):\nEmpresa / link usado (ex. /e/nome):\n\nObrigado.'
)
const MAIL_DELETE = `mailto:${PRIVACY_EMAIL}?subject=${DELETE_SUBJECT}&body=${DELETE_BODY}`

export function EliminarContaPage() {
  return (
    <main className={styles.page}>
      <div className={styles.inner}>
        <p className={styles.brand}>
          <Link to="/">GoBooking</Link>
        </p>
        <h1 className={styles.title}>Eliminar conta</h1>
        <p className={styles.updated}>
          Pedido de eliminação de conta e dados pessoais (RGPD / Google Play).
        </p>
        <nav className={styles.nav} aria-label="Documentos legais">
          <Link to="/privacidade">Privacidade</Link>
          <Link to="/termos">Termos</Link>
          <Link to="/eliminar-conta" className={styles.navActive}>
            Eliminar conta
          </Link>
        </nav>
        <article className={styles.body}>
          <p>
            Se pretende apagar a sua conta de cliente nesta plataforma de agendamentos e os dados associados
            (perfil, histórico de marcações, etc.), pode pedir a eliminação da seguinte forma:
          </p>

          <h2>1. Na aplicação (recomendado)</h2>
          <p>
            Com sessão iniciada: abra <strong>Minha conta / Perfil</strong> →{' '}
            <strong>Eliminar conta</strong> → confirme. A eliminação é permanente e remove a conta e os dados
            associados.
          </p>

          <h2>2. Pedido por e-mail</h2>
          <p>
            Envie um e-mail a partir do endereço associado à conta, com o assunto «Pedido de eliminação de
            conta»:
          </p>
          <p>
            <a className={styles.ctaMail} href={MAIL_DELETE}>
              Pedir eliminação — {PRIVACY_EMAIL}
            </a>
          </p>
          <p>Inclua, se possível:</p>
          <ul>
            <li>o e-mail da conta;</li>
            <li>o nome do negócio ou o link usado (ex.: <code>/e/sua-empresa</code>);</li>
            <li>confirmação de que pretende apagar a conta de forma permanente.</li>
          </ul>

          <h2>3. Pedido ao negócio</h2>
          <p>
            Se a sua conta foi criada no espaço de um salão / clínica concreto, também pode contactar esse
            negócio e pedir a eliminação dos seus dados junto deles. Eles gerem a relação comercial e os
            agendamentos.
          </p>

          <h2>4. Prazo</h2>
          <p>
            Tratamos os pedidos de eliminação no prazo razoável previsto na lei (em regra até 30 dias), salvo
            obrigação legal de conservar alguns registos. Após a eliminação, o login com essa conta deixa de
            ser possível.
          </p>

          <h2>5. Outros contactos</h2>
          <p>
            Privacidade: <a href={`mailto:${PRIVACY_EMAIL}`}>{PRIVACY_EMAIL}</a>
            <br />
            Comercial: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
          <p>
            Mais informação: <Link to="/privacidade">Política de Privacidade</Link>.
          </p>
        </article>
        <p className={styles.back}>
          <Link to="/">← Voltar ao início</Link>
        </p>
      </div>
    </main>
  )
}
